import React, { useState } from 'react';
import {
  TextField,
  MenuItem,
  FormControl,
  Box,
  CircularProgress,
} from '@mui/material';

export default function CPGoogleGeocode({setAddress1}) {
  const [cp, setCP] = useState('');
  const [colonias, setColonias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [coloniaSeleccionada, setColoniaSeleccionada] = useState('');

  const API_KEY = "AIzaSyBuQnb1hwxMpmznCme3xb4H3IcL2PZhvzw"
  const handleCPChange = async (e) => {
    const nuevoCP = e.target.value;
    setCP(nuevoCP);
    setColonias([]);
    setColoniaSeleccionada('');
    
    if (nuevoCP.length === 5 && /^\d{5}$/.test(nuevoCP)) {
      setLoading(true);
      try {
        const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${nuevoCP}|country:MX&key=${API_KEY}`
        );
        const data = await response.json();

        if (data.status === "OK") {
          const componentes = data.results.flatMap(result =>
            result.postcode_localities || [] // Asegúrate de que exista
          );

          const coloniasUnicas = [...new Set(componentes.filter(c => c && c.trim() !== ""))];

          setColonias(coloniasUnicas);
        } else {
          console.warn("No se encontraron resultados:", data.status);
        }
      } catch (err) {
        console.error("Error consultando Geocoding API:", err);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 2, flexDirection: 'row' }}>
      {/* Input CP */}
      <TextField
        label="Código Postal"
        value={cp}
        onChange={handleCPChange}
        fullWidth
        size='small'
        inputProps={{ maxLength: 5 }}
      />

      {/* Select de colonia */}
      <FormControl fullWidth>
        <TextField
          select
          size='small'
          label="Colonia"
          value={coloniaSeleccionada}
          onChange={(e) => { 
            setColoniaSeleccionada(e.target.value) 
            setAddress1(e.target.value+' '+cp)
          }}
          disabled={loading || colonias.length === 0}
          helperText={!colonias.length && cp.length === 5 && !loading ? "Sin colonias encontradas" : ""}
        >
          {loading ? (
            <MenuItem disabled>
              <CircularProgress size={20} />&nbsp; Buscando...
            </MenuItem>
          ) : (
            colonias.map((colonia) => (
              <MenuItem key={colonia} value={colonia}>
                {colonia}
              </MenuItem>
            ))
          )}
        </TextField>
      </FormControl>
    </Box>
  );
}
